import { DefaultDraftBlockRenderMap } from "draft-js";
import Immutable from "immutable";

import { BLOCK_TYPE } from "config/constants/editor";

const blockRenderMap = Immutable.Map({
  [BLOCK_TYPE.PLAIN_QUOTE]: {
    element: "div",
  },
  [BLOCK_TYPE.EMBED]: {
    element: "div",
  },
  [BLOCK_TYPE.QUOTE_ATTRIBUTION]: {
    element: "div",
  },
  [BLOCK_TYPE.IMAGE]: {
    element: "div",
  },
  [BLOCK_TYPE.KEEP_READING]: {
    element: "div",
  },
  [BLOCK_TYPE.AXIOM]: {
    element: "div",
  },
});

const extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(blockRenderMap);

export default extendedBlockRenderMap;
